<template>
  <div>
    <div v-if="type == 1">
      <div>
        (以下简称“本协议”)是甬金通数智金融应用（以下简称“本平台”）与用户（以下简称“您”）
        所订立的有效合约。请您先仔细阅读本协议内容，如您对本协议内容或页面提示信息有疑问，
        请勿进行下一步操作。您可通过客服热线（客服电话为：0574-89292467）进行咨询，以
        便我们为您解释和说明。如您通过页面点击或我们认可的其他方式确认本协议即表示您已同
        意本协议。
      </div>
<!--      <div>-->
<!--        一、声明与承诺-->
<!--      </div>-->
      <div>
        1、基于您的融资等需求，为便于您使用第三方的服务，您同意本平台将您的信息及页面提
        示的相关信息共享给第三方，包括但不限于向第三方提供查询、使用相关信用信息的服务。
        相关信息包括但不限于（1）工商信息、税务信息、社保信息、宁波人才码等信息（2）其他
        通过浙江省一体化数字资源系统可查询到的相关信息。本平台会要求第三方严格遵守相关法
        律法规与监管要求，依法使用您的信息，并对您的信息保密。
      </div>
      <div>
        2、上述第三方服务由该第三方独立运营并独立承担全部责任。因第三方服务或其使用您的
        信息而产生的纠纷，或第三方服务违反相关法律法规约定，或您在使用第三方服务过程中遭
        受损失的，请您和第三方协商解决。
      </div>
      <div>
        3、如本平台对本协议进行变更，我们将通过公告或客户端消息等方式予以通知，该等变更
        自通知载明的生效时间开始生效。若您不同意变更修改后的协议内容，您有权停止使用相关
        服务，并应在协议变更生效前停止使用本平台服务。
      </div>
<!--      <div>二、协议范围和服务内容</div>-->
<!--      <div>本协议是您与本平台关于您使用“宁波市普惠金融信用信息服务平台”所订立的协议。</div>-->
      <div>
        4、本协议未约定事宜，均以本平台网站公布的《用户注册服务协议》及相关规则为补充；
        本协议与《用户注册服务协议》及相关规则不一致的地方，以本协议为准。
      </div>
<!--      <div>三、用户注册和使用</div>-->
<!--      <div>您须在本平台注册，按照本平台要求提供相关信息并完成注册后方可使用本平台相关服务。</div>-->
      <div>

        5、本协议之效力、解释、变更、执行与争议解决均适用中华人民共和国法律。因本协议产生
        的争议，均应依照中华人民共和国法律予以处理，并由平台运行机构所在地仲裁委员会管辖。
      </div>
<!--      <div>（二）您须按照本平台认证要求准确、完整提供并及时更新相关信息，并对您所提供的信息-->
<!--        真实性、完整性负责。若本平台有合理理由怀疑您提供的信息或相关资料错误、不实、过时-->
<!--        或不完整的，本平台有权暂停或终止向您提供部分或全部服务，本平台对此不承担任何责任。-->
<!--        若因国家法律法规、部门规章或监管机构的要求，本平台需要您补充提供任何信息或相关资-->
<!--        料时，如您不能及时提供，本平台有权暂停或终止向您提供部分或全部服务。-->
<!--      </div>-->
<!--      <div>（三）您如果通过使用浙江法人数字证书登录本平台，您同意视同本平台已注册用户，并接-->
<!--        受本协议相关条款。-->
<!--      </div>-->
<!--      <div>（四）注册用户对自行发表、上传或传送的内容负全部责任，所有用户不得在本平台任何页-->
<!--        面发布、转载、传送含有下列内容之一的信息，否则本平台有权自行处理并不通知用户：-->
<!--      </div>-->
<!--      <div>1、违反宪法确定的基本原则的；</div>-->
<!--      <div>2、危害国家安全，泄漏国家机密的；</div>-->
<!--      <div>3、损害国家荣誉和利益的；</div>-->
<!--      <div>4、煽动民族仇恨、民族歧视，破坏民族团结的；</div>-->
<!--      <div>5、破坏国家宗教政策，宣扬邪教和封建迷信的；</div>-->
<!--      <div>6、散布谣言，扰乱社会秩序，破坏社会稳定的；</div>-->
<!--      <div>7、散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；</div>-->
<!--      <div>8、侮辱或者诽谤他人，侵害他人合法权益的;</div>-->
<!--      <div>9、含有法律、行政法规禁止的其他内容的。</div>-->
<!--      <div>（五）注册用户在使用本平台服务时如违反下述任何规定，本平台有权要求用户改正或直接-->
<!--        采取一切必要的措施(包括但不限于删除用户张贴的内容、暂停或终止用户使用本平台服务-->
<!--        的权利)以减轻用户不当行为而造成的影响。-->
<!--      </div>-->
<!--      <div>1、不得为任何非法目的而使用本平台服务；</div>-->
<!--      <div>2、遵守所有与本平台服务有关的网络协议、规定和程序；</div>-->
<!--      <div>3、不得利用本平台进行任何可能对互联网的正常运转造成不利影响的行为；</div>-->
<!--      <div>4、不得利用本平台进行任何不利于本平台的行为。</div>-->
<!--      <div>四、授权条款</div>-->
<!--      <div>在您登录、使用本平台相关服务时：</div>-->
<!--      <div>（一）您允许本平台自动接收并记录您手机/浏览器上的服务器数据，包括但不限于 IP 地址、-->
<!--        网站 Cookie 中的资料及您要求取用的网页记录-->
<!--      </div>-->
<!--      <div>（二）您同意本平台在您使用本平台相关功能时，可根据需要采集包括但不限于政府部门、-->
<!--        公用事业单位、金融机构等在履职过程中记录的相关信用信息。-->
<!--      </div>-->
<!--      <div>（三）您允许您发布融资需求等业务时，本平台向您定向或公开发布融资需求等业务的金融-->
<!--        机构及本平台认可的机构提供查询、使用相关信用信息的服务；如果融资成功，您认可本平-->
<!--        台在您所获得的融资存续期内继续向上述机构提供查询、使用相关信用信息的服务，并同意-->
<!--        上述机构及平台运行机构通过电话等方式对接、了解您发布的融资需求等业务。-->
<!--      </div>-->
<!--      <div>（四）您同意并授权本平台，在您使用本平台合作的第三方应用相关服务时，向第三方应用-->
<!--        提供方提供查询、使用相关信息的服务。-->
<!--      </div>-->
<!--      <div>五、免责条款</div>-->
<!--      <div>您理解并同意，本平台在以下情况下不承担责任（包括但不限于）：</div>-->
<!--      <div>（一）本平台无法保证网络服务一定能满足用户的要求，也不保证网络服务的及时性、安全-->
<!--        性、准确性。-->
<!--      </div>-->
<!--      <div>（二）对于因不可抗力或本平台不能控制的原因造成的网络服务中断或其它缺陷，本平台不-->
<!--        承担任何责任，但将尽力减少因此而给用户造成的损失和影响。-->
<!--      </div>-->
<!--      <div>（三）本平台有权在任何时间暂时或永久修改或终止本服务(或其任何部分)，而无论其通知-->
<!--        与否，本平台对用户和任何第三人均无需承担任何责任。-->
<!--      </div>-->
<!--      <div>（四）用户通过本平台发生的融资对接行为以及对接成功后发生的金融活动，由对接双方分-->
<!--        别承担相应法律责任，本平台不承担由此引发的法律责任。-->
<!--      </div>-->
<!--      <div>（五）本平台不承诺用户融资对接的成功，因任何原因导致对接不成功的，本平台不承担法-->
<!--        律责任。-->
<!--      </div>-->
<!--      <div>（六）用户通过本平台与本平台合作的第三方应用提供方进行任何形式的对接活动，完全为-->
<!--        用户与第三方应用提供方之间的行为，本平台对此不承担任何法律责任。-->
<!--      </div>-->
<!--      <div>六、附则</div>-->
<!--      <div>（一）本协议的成立、生效、履行、解释及纠纷解决，适用中华人民共和国法律，按照法律-->
<!--        解决，法律无明文规定的，可适用中华人民共和国通行的金融惯例。-->
<!--      </div>-->
<!--      <div>（二）若您和本平台就本协议内容或其执行发生任何争议的，双方应友好协商解决；双方无-->
<!--        法协商解决争议时，您可以依据适用的法律向平台运行机构所在地仲裁委员会申请仲裁解决。-->
<!--      </div>-->
<!--      <div>（三）若本协议的部分条款被认定为无效或者无法实施时，本协议中的其他条款仍然有效。</div>-->
<!--      <div>（四）本平台运行机构在法律许可的范围内对本协议享有最终的解释权。</div>-->
<!--      <div></div>-->
<!--      <div></div>-->
<!--      <div></div>-->
<!--      <div></div>-->
<!--      <div></div>-->
<!--      <div></div>-->
<!--    </div>-->
<!--    <div v-else>-->
<!--      <div>我们深知您的信息重要性，也感谢您对我们的信任。我们将通过本政策向您说明宁波市普惠-->
<!--        金融信用信息服务平台（以下简称“本平台” ，由宁波市资金清算中心负责运行，注册地址/-->
<!--        常用办公地址：宁波市江东北路 138 号）会如何收集、存储、保护、使用及对外提供您信-->
<!--        息，并说明您享有的权利。建议您仔细阅读并理解本政策全部内容，做出您认为适当的选择。-->
<!--      </div>-->
<!--      <div>一、我们如何收集信息</div>-->
<!--      <div>为了您可以正常使用本平台服务，下列情形下您需要向我们提供相关信息：</div>-->
<!--      <div>（一）注册及登陆。当您通过本平台 APP、官方门户网站（https://www.phcredit.com.cn/）-->
<!--        注册认证用户时，须提供您的姓名、手机号、身份证号码、脸部图像或视频等，以核验您的-->
<!--        身份。我们会将您提供的信息合法传送至存有您信息的第三方机构进行实名制验证。-->
<!--      </div>-->
<!--      <div>（二）网点查询。当您使用本平台查询附近网点服务时，需要您开启手机的地理位置获取权-->
<!--        限，以便获取您的当前位置信息，为您展示附近的金融机构网点信息。如您不提供前述权限，-->
<!--        可能无法为您提供附近的上述相关服务，但不影响您使用我们提供的其他服务。-->
<!--      </div>-->
<!--      <div>（三）个性化服务。我们可能会收集您登陆使用平台服务时的浏览信息、关注信息，搜索记-->
<!--        录进行数据统计分析，形成群体特征的用户画像，以便为您提供您感兴趣的个性化服务。-->
<!--        （四）客户服务。我们会收集您使用本平台意见反馈等服务时向我们发送的信息。如您不提-->
<!--        供前述信息，不影响您使用我们提供的其他服务。-->
<!--      </div>-->
<!--      <div>（五）根据相关法律法规，我们可能会依法收集并使用您的信息，而无需征得您的同意。</div>-->
<!--      <div>二、我们如何存储和保护信息</div>-->
<!--      <div>（一）为了保障您的信息安全，我们在收集您的信息后，将采取各种合理必要的措施保护您-->
<!--        的信息。-->
<!--      </div>-->
<!--      <div>（二）我们致力于使用各种安全技术及配套的管理体系来尽量降低您的信息被泄露、毁损、-->
<!--        误用、非授权访问、非授权披露和更改的风险。-->
<!--      </div>-->
<!--      <div>（三）请您务必妥善保管好您的手机账号及其他身份要素。一旦您泄漏了前述信息，可能对-->
<!--        您产生不利。如您发现手机账号及/或其他身份要素可能或已经泄露时，请您立即和我们取-->
<!--        得联系，以便我们及时采取相应措施以避免或降低对您可能产生的不利。-->
<!--      </div>-->
<!--      <div>三、我们如何使用信息</div>-->
<!--      <div>为遵守国家法律法规及监管要求，以及向您提供服务及提升服务质量，或保障您的账户安全，-->
<!--        我们会在以下情形中使用您的信息：-->
<!--      </div>-->
<!--      <div>（一）实现本政策中“我们如何收集信息”所述目的；</div>-->
<!--      <div>（二）根据法律法规或监管要求向相关部门进行报告。</div>-->
<!--      <div>四、我们如何对外提供信息 </div>-->
<!--      <div>（一）信息共享及查询</div>-->
<!--      <div>我们承诺仅在以下情形中与第三方共享、开放查询您的信息，第三方包括我们合作的金融机-->
<!--        构以及其他合作伙伴。如果为向您提供服务而需要将您的信息共享至第三方，我们将要求第-->
<!--        三方对您的信息采取保护措施，并且严格遵守相关法律法规与监管要求。另外，我们会按照-->
<!--        法律法规的要求以确认协议等形式征得您的同意。</div>-->
<!--      <div>1、在第三方已经线下征得您的授权情况下，我们会在法律允许范围内，依据您的授权允许-->
<!--        第三方查询您的信息；</div>-->
<!--      <div>2、您的需求或其他服务需要第三方提供对接的，只有共享您的信息才能提供您需要的需求-->
<!--        或服务。</div>-->
<!--      <div>（二）转让</div>-->
<!--      <div>我们不会将您的信息转让给任何公司、组织和个人，但以下情况除外：</div>-->
<!--      <div>1、事先获得您的明确同意；</div>-->
<!--      <div>2、根据法律法规或强制性的行政或司法要求。</div>-->
<!--      <div>（三）公开披露</div>-->
<!--      <div>原则上我们不会将您的信息进行公开披露。如确需公开披露时，我们会向您告知公开披露的-->
<!--        目的、披露信息的类型及可能涉及的敏感信息，并征得您的明确同意。</div>-->
<!--      <div>（四）根据相关法律法规，在以下情形中，我们可能会依法共享、转让、公开披露您的信息-->
<!--        无需征得您的同意：</div>-->
<!--      <div>（1）与履行法律法规及行业主管部门规定的义务相关的；</div>-->
<!--      <div>（2）与国家安全、国防安全直接相关的；</div>-->
<!--      <div>（3）与公共安全、公共卫生、重大公共利益直接相关的；</div>-->
<!--      <div>（4）与犯罪侦查、起诉、审判和判决执行等直接相关的；</div>-->
<!--      <div>（5）出于维护您或其他个人的生命、财产等重大合法权益但又很难得到您本人同意的；</div>-->
<!--      <div>（6）您自行向社会公众公开的信息；</div>-->
<!--      <div>（7）从合法公开披露的信息中收集的信息，例如：合法的新闻报道、政府信息公开等渠道。</div>-->
<!--      <div>五、您如何访问和管理您的信息</div>-->
<!--      <div>在您使用本平台服务期间，为了您可以更加便捷地访问和管理您的信息，我们在客户端中为-->
<!--        您提供了相应的操作设置，您可以参考下面的指引进行操作。</div>-->
<!--      <div>（一）管理您的信息</div>-->
<!--      <div>1、您可通过登录本平台官方网站，在“用户中心”中，以及从本平台 APP 登录，在“我的→信-->
<!--        息”中根据页面提示自助管理您的信息。</div>-->
<!--      <div>2、如发现您的信息有误，您可以根据页面提示自助修改维护您的信息。对于您无法自助修-->
<!--        改的信息，您可以按照本平台提供的其他方式发起申请。</div>-->
<!--      <div>（二）管理您的授权范围</div>-->
<!--      <div>如您想改变授权范围，您可通过平台 APP“我的→信用信息维护”修改授权范围，取消向第三-->
<!--        方共享信息的授权。在您取消向第三方共享信息的授权后，我们将不再向该第三方提供查询、-->
<!--        使用您的信息的服务。</div>-->
<!--      <div>（三）如您发现我们收集、使用您的信息行为，违反了法律法规规定或违反了与您的约定，-->
<!--        您可联系我们的客服热（0574-87058336），要求删除相应的信息。</div>-->
<!--      <div>（四）尽管有上述约定，但按照相关法律法规及国家标准，在以下情形中，我们可能无法响-->
<!--        应您的请求：</div>-->
<!--      <div>1、与国家安全、国防安全直接相关的；</div>-->
<!--      <div>2、与公共安全、公共卫生、重大公共利益直接相关的；</div>-->
<!--      <div>3、与犯罪侦查、起诉、审判和执行判决等直接相关的；</div>-->
<!--      <div>4、有充分证据表明您存在主观恶意或滥用权利的；</div>-->
<!--      <div>5、响应您的请求将导致其他个人、组织的合法权益受到严重损害的；</div>-->
<!--      <div>6、涉及商业秘密的。</div>-->
<!--      <div>六、对第三方责任的声明</div>-->
<!--      <div>（一）为了提供更好的服务和用户体验，本平台可能接入或链接至第三方提供的应用服务（包-->
<!--        括但不限于网站、第三方应用或其他服务方式）。在您使用了由第三方而非本平台提供的服-->
<!--        务时，我们会尽力确保您的信息在传输过程中的安全，使您获得更安全的访问体验。</div>-->
<!--      <div>（二）您通过我们网站或 app 链接访问的第三方应用或服务，可能有自己的隐私权保护政-->
<!--        策。当您查看第三方创建的网页或使用第三方开发的应用程序时，这些第三方可能会放置他-->
<!--        们自己的 Cookie，这些 Cookie 不受我们的控制，且它们的使用不受本政策的约束。我们会-->
<!--        努力去要求这些主体对您的信息采取保护措施，建议您与他们联系以获得关于他们的隐私权-->
<!--        政策的详细情况。如您发现这些第三方创建的网页或第三方开发的应用程序存在风险时，建-->
<!--        议您终止相关操作以保护您的合法权益。</div>-->
<!--      <div>七、本政策的适用及更新</div>-->
<!--      <div>本平台所有服务均适用本政策，除非相关服务已有独立的隐私权政策或相应的用户服务协议-->
<!--        当中存在的特殊约定。</div>-->
<!--      <div>为了提供更好的服务，我们会适时根据本平台服务功能及法律法规的相关要求对本政策的条-->
<!--        款进行更新修改，如本政策发生更新，我们将以 APP 推送通知、短消息或者在官方网站发-->
<!--        布公告等方式来通知您。如您在本政策更新生效后继续使用本平台服务，即表示您已充分阅-->
<!--        读、理解并接受更新后的政策并愿意受更新后的政策约束。</div>-->
<!--      <div>您可以在本平台官方网站首页查看本政策，也可在 APP 端通过“我的→隐私和个人信息条款” 中查看本政策。我们鼓励您在每次使用本平台服务时都查阅我们的隐私政策</div>-->
    </div>
  </div>

</template>

<script>
export default {
  name: "Agreement",
  props: ["type"]
}
</script>

<style lang="scss" scoped>
.title {
  font-size: 16px;
  font-weight: bolder;
  text-align: center;
}
</style>
